import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import { hasSecurityPackage } from '@adjust/dashboard-core/lib/utils/account';
import { fetchAccountData } from '@redux/ducks/accountData';
import { getCurrentAccount } from '@redux/ducks/global';
import { fetchPaymentMethod } from '@redux/ducks/paymentMethods';
import { fetchData as fetchInvoicesChargeData } from '@redux/ducks/invoices';
import { fetchData as fetchTwoFactorConfiguration } from '@redux/ducks/twoFactorConfiguration';
import { initialize as initializeAudit } from '@redux/ducks/historyEvents';

// Workers

export function* fetchDataTask() {
  try {
    const currentAccount = yield select(getCurrentAccount);

    if (currentAccount.payment_method === 'credit card') {
      yield put(fetchPaymentMethod());
    }

    if (!currentAccount.in_demo_period) {
      yield put(fetchInvoicesChargeData({ invoicesLimit: 3 }));
    }

    const isTwoFactorAvailable = yield call(hasSecurityPackage, currentAccount);

    if (isTwoFactorAvailable) {
      yield put(fetchTwoFactorConfiguration());
    }

    yield put(initializeAudit({ limit: 5 }));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
}

// Watchers

export function* watchFetchData() {
  yield takeLatest(fetchAccountData, fetchDataTask);
}

// Saga

export default function* accountDataSaga() {
  yield all([watchFetchData()]);
}
